import { Component, Injector, OnInit } from '@angular/core';
import { ReviewCreditStep } from '../../../models/wizard/review-credit-step.model';
import { WizardStepComponentBase } from '../wizard-step-base.component';
import { Liability, RealEstateOwned } from '../../../models/mortgage.model';
import { activeOnly } from '../../../utils/entity-state';

@Component({
    selector: 'review-credit-step',
    templateUrl: 'review-credit-step.component.html',
    standalone: false
})
export class ReviewCreditStepComponent extends WizardStepComponentBase<ReviewCreditStep> implements OnInit {

  constructor(private readonly _injector: Injector) {
    super(_injector);
    this.saveMortgageApplicationBeforeNextStep = true;
  }

  liabilities: Liability[] = [];
  reos: RealEstateOwned[] = [];

  ngOnInit() {
    this.reos = activeOnly(this.mortgageApplication.realEstateOwned);
    if (this.inCoApplyFlow) {
      this.reos = this.reos.filter(r => r.owningBorrowerIds.includes(this.currentBorrower.borrowerId!));
    }
    this.liabilities = activeOnly(this.mortgageApplication.liabilities)
      .filter(r => r.typeOfLiability == 'MortgageLoan' || r.typeOfLiability == 'HELOC')

    if (this.inCoApplyFlow) {
      this.liabilities = this.liabilities.filter(l => l.owningBorrowerIds.includes(this.currentBorrower.borrowerId!));
    }
    if (this.isEditEnabled) {
      return;
    }
    if (!this.liabilities || this.liabilities.length == 0) {
      if (this.cameHereWithBackNavigation) {
        this.wizardFlowService.navigateBackward();
      } else {
        this.onNextClicked();
      }
    }
  }
}
